import { number, object, ObjectSchema, string } from "yup";

export interface FormSchema {
	editItemsLineNumber: number;
	productSelectQuantity: number;
	destinationConfigurationId?: string;
}

const editLineItemSchemaObject = {
	editItemsLineNumber: number().required(),
	productSelectQuantity: number().required(),
	destinationConfigurationId: string()
} as const;

export const schema: ObjectSchema<FormSchema> = object(editLineItemSchemaObject);
